export default {
  getFullName(state) {
    return state.user_full_name;
  },
  getEntityTypes(state) {
    return state.user_entity_types;
  }
}
